export const JOB_OPTIONS: { name: string, key: string }[] = [
    {key: 'solver_run', name: 'Solver Run'},
    {key: 'jde_invoice', name: 'Invoice'},
    {key: 'series_correction', name: 'Series Correction'},
    {key: 'series_calculation', name: 'Series Calculation'},
    {key: 'component_download', name: 'Component Download'},
];

export const JOB_STATUS_OPTIONS: string[] = ['pending', 'processing', 'completed', 'error'];

export enum JOB_STATUS {
    PENDING,
    PROCESSING,
    COMPLETED,
    ERROR
}
